// Device Action
export const ADD_DEVICE = 'ADD_DEVICE';
export const EDIT_DEVICE = 'EDIT_DEVICE';
export const DELETE_DEVICE = 'DELETE_DEVICE';


// Accessory Action
export const ADD_ACCESSORY = 'ADD_ACCESSORY';
export const EDIT_ACCESSORY = 'EDIT_ACCESSORY';
export const DELETE_ACCESSORY = 'DELETE_ACCESSORY';


// Offer Action
export const ADD_OFFER = 'ADD_OFFER';
export const EDIT_OFFER = 'EDIT_OFFER';
export const DELETE_OFFER = 'DELETE_OFFER';
export const DELETE_ACCESSORY_FROM_OFFER = 'DELETE_ACCESSORY_FROM_OFFER';


// LogIn Action
export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';


// Notification Action
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';